import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Округляет денежную сумму до 2 знаков после запятой, не дописывая лишние нули. */
export function formatMoney(value: number) {
  return (Math.round(value * 100) / 100).toString()
}

function pluralizeRu(n: number, one: string, few: string, many: string) {
  const mod10 = n % 10
  const mod100 = n % 100
  if (mod10 === 1 && mod100 !== 11) return one
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return few
  return many
}

/** «5 минут назад» / «2 часа назад» и т.п. по разнице с текущим временем. */
export function formatRelativeTime(iso: string): string {
  const diffSec = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 1000))

  if (diffSec < 60) return 'только что'

  const diffMin = Math.round(diffSec / 60)
  if (diffMin < 60) return `${diffMin} ${pluralizeRu(diffMin, 'минуту', 'минуты', 'минут')} назад`

  const diffHours = Math.round(diffMin / 60)
  if (diffHours < 24) return `${diffHours} ${pluralizeRu(diffHours, 'час', 'часа', 'часов')} назад`

  const diffDays = Math.round(diffHours / 24)
  if (diffDays < 30) return `${diffDays} ${pluralizeRu(diffDays, 'день', 'дня', 'дней')} назад`

  return new Date(iso).toLocaleDateString('ru-RU')
}
